class VideoGIF extends HTMLElement {
  constructor() {
      super();
      const video = this.querySelector('.video');
      const playPauseButton = this.querySelector('.play-pause-button');
      let isPlaying = false; // 初始化状态为 false

      // 确保 video 元素存在
      if (!video || !playPauseButton) {
          console.error('Video or playPauseButton not found');
          return;
      }

      // 尝试播放视频
      let videoTimer2 = setTimeout(() => {
        video.play().then(() => {
          clearTimeout(videoTimer2);
          isPlaying = true;
      }).catch(error => {
          console.error('Error during initial play:', error);
      });
      }, 1000);

      

      const initPlayGifVideo = setInterval(() => {
          if (video.ended) {
              video.play();
          }
      }, 2000);

      // 事件监听器
      playPauseButton.addEventListener('click', togglePlayPause);

      // 处理 Enter 和 Space 键事件
      playPauseButton.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault(); // 阻止默认行为
              togglePlayPause();
          }
      });

      function togglePlayPause() {
          if (isPlaying) {
              video.pause();
              playPauseButton.textContent = '▶'; // 播放图标
              clearInterval(initPlayGifVideo);
          } else {
              video.play().then(() => {
                  isPlaying = true;
                  playPauseButton.textContent = '❚❚'; // 暂停图标
              }).catch(error => {
                  console.error('Error during play:', error);
              });
          }
          isPlaying = !isPlaying; // 切换状态
      }
  }
}

// 定义自定义元素
customElements.define('video-gif', VideoGIF);
